/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
const nameSpace = 'COMPANY'
export const COMAPNYLIST = `${nameSpace}_COMPANYLIST`
export const ADMINCOMAPNYLIST = `${nameSpace}_ADMINCOMAPNYLIST`
export const DEFAULTCOMPANY = `${nameSpace}_DEFAULTCOMPANY`
export const ACTIVE_AMOUNT = `${nameSpace}_ACTIVE_AMOUNT`
